function bindSwymSharedWishlitPageData(swat) {
    const queryParams = swat.utils.getEncodedAsObject(window.location.search);
    const sharedHkey = queryParams["hkey"] || queryParams["lid"];
    const sharedWishlistContainerElement = document.querySelector(
        "#swym-shared-wishlist-render-container"
    );
    swat.ui.renderSharedWishlistInContainer(
        sharedWishlistContainerElement,
        sharedHkey,
        queryParams
    );
}

function initSwymSharedWishlistPage(swat) {
    bindSwymSharedWishlitPageData(swat);
}

window.SwymCallbacks = window.SwymCallbacks || [];
window.SwymCallbacks.push(initSwymSharedWishlistPage);